<template>
  <button @click="handleClick">
    Test
  </button>
</template>

<script>
export default {
  name: "k-test",
  props: {},
  data() {
    return {};
  },

  methods: {
    handleClick(event) {
      this.$emit("click", event);
    }
  },
  mounted() {}
};
</script>
